<template>
	<div class="transactions-section">
		<div class="section-content">
			<h3 class="section-title">{{ title }}</h3>
			<div class="day-groups">
				<div v-for="(day, dayIndex) in filteredDays" :key="dayIndex" v-show="getLimitedPurchases(day, dayIndex).length > 0" class="day-group">
					<p class="day-header">{{ formatDayHeader(day.date, day.purchases.length) }}</p>
					<div class="day-transactions">
						<RecentDiscountTransactionItem
							v-for="(purchase, purchaseIndex) in getLimitedPurchases(day, dayIndex)"
							:key="purchaseIndex"
							:merchantName="purchase.merchantName"
							:icon="purchase.icon"
							:faceValue="purchase.faceValue"
							:savedToSpendEarningsAmount="purchase.savedToSpendEarningsAmount"
							:savingPercentage="purchase.savingPercentage"
							:usedSavedToSpend="purchase.usedSavedToSpend"
							:formatter="formatter"
						/>
					</div>
				</div>
			</div>
			<button v-if="hasMoreDays" class="view-more-button" @click="$emit('view-more')">
				<span>{{ viewMoreText }}</span>
				<img :src="require('@/assets/arrow-right.png')" alt="arrow" class="arrow-icon" />
			</button>
		</div>
	</div>
</template>

<script>
import RecentDiscountTransactionItem from './RecentDiscountTransactionItem.vue';

export default {
	name: 'DiscountTransactionsSection',
	components: { RecentDiscountTransactionItem },
	props: {
		title: {
			type: String,
			default: 'Latest activity'
		},
		days: {
			type: Array,
			default: () => []
		},
		maxDays: {
			type: Number,
		},
		maxVouchers: {
			type: Number,
		},
		viewMoreText: {
			type: String,
			default: 'View more'
		},
		formatter: {
			type: Object,
			default: () => ({ format: v => '£' + v.toFixed(2) })
		}
	},
	emits: ['view-more'],
	computed: {
		filteredDays() {
			const filtered = this.days.filter(day => day.purchases && day.purchases.length > 0);
			return this.maxDays != null ? filtered.slice(0, this.maxDays) : filtered;
		},
		hasMoreDays() {
			if (this.maxDays == null && this.maxVouchers == null) return false;
			const daysWithPurchases = this.days.filter(day => day.purchases && day.purchases.length > 0);
			const totalPurchases = daysWithPurchases.reduce((sum, day) => sum + day.purchases.length, 0);
			return (this.maxDays != null && daysWithPurchases.length > this.maxDays) ||
				(this.maxVouchers != null && totalPurchases > this.maxVouchers);
		}
	},
	methods: {
		getLimitedPurchases(day, dayIndex) {
			if (this.maxVouchers == null) return day.purchases;
			let countBefore = 0;
			for (let i = 0; i < dayIndex; i++) {
				countBefore += this.filteredDays[i].purchases.length;
			}
			const remaining = this.maxVouchers - countBefore;
			if (remaining <= 0) return [];
			return day.purchases.slice(0, remaining);
		},
		formatDayHeader(dateString, count) {
			const date = new Date(dateString);
			const today = new Date();
			const yesterday = new Date(today);
			yesterday.setDate(yesterday.getDate() - 1);

			const isToday = date.toDateString() === today.toDateString();
			const isYesterday = date.toDateString() === yesterday.toDateString();

			let dayLabel;
			if (isToday) {
				dayLabel = 'Today';
			} else if (isYesterday) {
				dayLabel = 'Yesterday';
			} else {
				const day = date.getDate();
				const month = date.toLocaleDateString('en-GB', { month: 'long' });
				dayLabel = `${day} ${month}`;
			}

			return `${dayLabel} (${count})`;
		}
	}
}
</script>

<style scoped>
.transactions-section {
	background: #FFFFFF;
	border-radius: 8px;
	padding: 20px;
}

.section-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
}

.section-title {
	font-size: 14px;
	font-weight: bold;
	color: #413655;
	margin: 0;
	text-align: center;
}

.day-groups {
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
}

.day-group {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.day-header {
	font-size: 14px;
	font-weight: bold;
	color: #413655;
	margin: 0;
}

.day-transactions {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.view-more-button {
	display: flex;
	align-items: center;
	gap: 4px;
	background: transparent;
	border: none;
	cursor: pointer;
	padding: 0;
}

.view-more-button span {
	font-size: 13px;
	font-weight: bold;
	color: #413655;
}

.arrow-icon {
	width: 14px;
	height: 10px;
	padding-left: 2px;
}
</style>
